
import React from "react";
import Footer from "../Components/Footer/Footer";
import Product from "../Components/Product/ProductMain/Product";

const ProductDetails: React.FC = () => {
  return (
    <>
      <Product/>
      <Footer />
    </>
  );
};

export default ProductDetails;
